// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import TransactionModifyModal from './transaction-modify.modal.js';
import TransactionCreditModifyModal from './transaction-credit-modify.modal.js';
import Organization from '../organization/organization.model.js';
import Invoice from '../invoice/invoice.model.js';

import { deleteTransaction } from '../transaction/transaction.actions.js';

import { selectUIProgress, selectUIModal } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';

import { transactionsSelector, transactionsListSelector } from './transaction.selectors.js';
import { EDIT_TRANSACTION, MODAL_EDIT_CREDIT } from './transaction.const.js';

import { invoicesSelector, invoiceSelector } from '../invoice/invoice.selectors.js';
import { organizationsSelector } from '../organization/organization.selectors.js';
import { payerSelector, userSelector } from '../user/user.selectors.js';

export class TransactionsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      actionType: '',
      transactionId: ''
    };

    this.onRefundClick = this.openModal.bind(this, 'refund');
    this.onEditClick = this.openModal.bind(this, 'edit');
    this.onIncreaseClick = this.openModal.bind(this, 'increase');

    this.confirm = this.confirm.bind(this);
  }

  openModal(type, e) {
    const { transactionId } = e.currentTarget.dataset;
    const { transactions } = this.props;
    const transaction = transactions[transactionId];
    this.setState({
      actionType: type,
      transactionId
    });
    if (transaction.incomeSourceType === 'credit') {
      return this.props.setModal(true, MODAL_EDIT_CREDIT);
    }
    return this.props.setModal(true, EDIT_TRANSACTION);
  }

  confirm(e) {
    return confirm('Are you sure?')
      ? this.props.deleteTransaction(e.currentTarget.dataset.transactionId)
      : false;
  }

  render() {
    const {
      transactionsView,
      invoiceView,
      progress,
      transactionsList,
      transactions,
      organizations,
      invoices,
      invoice,
      user,
      payer,
      filter
    } = this.props;

    if (!transactionsList.length) return null;

    const showOrgColumn = user.id === payer.id || !Organization.orgAccess;

    let filterTransactionsList = transactionsList;
    if (filter === 'Credits')
      filterTransactionsList = filterTransactionsList.filter(
        transactionId => transactions[transactionId].incomeSourceType === 'credit'
      );
    if (filter === 'Invoices')
      filterTransactionsList = filterTransactionsList.filter(
        transactionId => transactions[transactionId].invoiceId
      );
    if (filter === 'Payments')
      filterTransactionsList = filterTransactionsList.filter(
        transactionId => transactions[transactionId].directionType === 'outcome'
      );

    return (
      <span>
        <TransactionModifyModal {...this.state} />
        <TransactionCreditModifyModal type="edit" transactionId={this.state.transactionId} />

        <div className="panel panel-default">
          <div className="table-responsive">
            <table className="table table-sm table-hover table-panel table-panel-td-border">
              <thead>
                <tr>
                  <th className={`text-left col-md-${showOrgColumn ? '1' : '2'}`}>Transaction #</th>
                  {showOrgColumn ? (
                    <th className={`text-left col-md-${showOrgColumn ? '2' : '3'}`}>
                      Organization
                    </th>
                  ) : null}
                  {transactionsView ? (
                    <React.Fragment>
                      <th className="text-right col-md-1">Invoice</th>
                      <th className="text-right col-md-1">Direction type</th>
                    </React.Fragment>
                  ) : null}
                  <th className="text-right col-md-1">Amount Paid</th>
                  <th className="text-right col-md-2">Transaction Date</th>
                  {!invoiceView ? (
                    <th className="text-center col-md-2">Income source type</th>
                  ) : null}
                  <th className="text-center col-md-1">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filterTransactionsList.map(id => {
                  const transaction = transactions[id];
                  const org = organizations[transaction.organizationId];

                  if (!org) return null;

                  return (
                    <tr key={`transactions-${id}`}>
                      <td className={`text-left col-md-${showOrgColumn ? '1' : '2'}`}>#{id}</td>
                      {showOrgColumn ? (
                        <td className={`text-left col-md-${showOrgColumn ? '2' : '3'}`}>
                          {org.name}
                        </td>
                      ) : null}
                      {transactionsView ? (
                        <React.Fragment>
                          <td className="text-right col-md-2">
                            {transaction.invoiceId && invoices[transaction.invoiceId] ? (
                              <a href={Invoice.getInvoiceLink(transaction.invoiceId, org.unique)}>
                                #{invoices[transaction.invoiceId].number}
                              </a>
                            ) : (
                              '―'
                            )}
                          </td>
                          <td className="text-right col-md-1">{transaction.directionType}</td>
                        </React.Fragment>
                      ) : null}
                      <td className="text-right col-md-1">${transaction.amount}</td>
                      <td className="text-right col-md-2">{transaction.createdDateTime}</td>
                      {!invoiceView ? (
                        <td className="text-center col-md-2">
                          {transaction.incomeSourceType || '―'}
                        </td>
                      ) : null}
                      <td className="text-center col-md-2">
                        <div className="action-btns-wrap">
                          {transaction.editable ? (
                            !Organization.orgAccess && transaction.directionType === 'outcome' ? (
                              <button
                                disabled={progress}
                                data-transaction-id={id}
                                onClick={this.onIncreaseClick}
                                className="btn btn-xs btn-success btn-action"
                              >
                                Increase
                              </button>
                            ) : (
                              <button
                                disabled={progress}
                                data-transaction-id={id}
                                onClick={this.onEditClick}
                                className="btn btn-xs btn-success btn-action"
                              >
                                Edit
                              </button>
                            )
                          ) : null}
                          {transaction.deletable ? (
                            <button
                              disabled={progress}
                              className="btn btn-xs btn-default btn-action"
                              data-transaction-id={id}
                              onClick={this.confirm}
                            >
                              Delete
                            </button>
                          ) : null}
                          {transaction.refundable ? (
                            <button
                              disabled={progress}
                              data-transaction-id={id}
                              onClick={this.onRefundClick}
                              className="btn btn-xs btn-success btn-action"
                            >
                              Refund
                            </button>
                          ) : null}
                          {!transaction.refundable &&
                          !transaction.editable &&
                          !transaction.deletable
                            ? '—'
                            : null}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </span>
    );
  }
}

const progressSelector = selectUIProgress();
const modalSelector = selectUIModal(EDIT_TRANSACTION);

const mapStateToProps = state => ({
  isOpen: modalSelector(state),
  progress: progressSelector(state),
  organizations: organizationsSelector(state),
  user: userSelector(state),
  payer: payerSelector(state),
  invoices: invoicesSelector(state),
  transactions: transactionsSelector(state),
  transactionsList: transactionsListSelector(state)
});

export default connect(
  mapStateToProps,
  {
    setModal,
    deleteTransaction
  }
)(TransactionsTable);
